"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/of");
require("rxjs/add/observable/zip");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var portfolio_row_model_1 = require("./portfolio-row.model");
var portfolio_cell_model_1 = require("./portfolio-cell.model");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var Subject_1 = require("rxjs/Subject");
var wf_bulk_action_popup_model_1 = require("./wf-bulk-action-popup.model");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var portfolio_filter_dto_1 = require("../model/portfolio-filter-dto");
var idm_de_core_frontend_2 = require("@synisys/idm-de-core-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var column_type_1 = require("../model/column-type");
var table_column_type_1 = require("../model/table-column-type");
var operators_1 = require("rxjs/operators");
var router_1 = require("@angular/router");
var store_1 = require("@ngrx/store");
var kb_prefix_1 = require("../../service/kb-prefix");
var PortfolioService = /** @class */ (function () {
    function PortfolioService(currentLanguageProvider, kbService, formResolverService, entitySearchService, actionService, deservice, validationService, store, router, route, languageService, kbPrefix) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.kbService = kbService;
        this.formResolverService = formResolverService;
        this.entitySearchService = entitySearchService;
        this.actionService = actionService;
        this.deservice = deservice;
        this.validationService = validationService;
        this.store = store;
        this.router = router;
        this.route = route;
        this.languageService = languageService;
        this.kbPrefix = kbPrefix;
        this._pageSizeForParentFilter = 300;
        this.columnFields = [];
        this._searchNames = new Map();
        this._externalFilters = {};
        /**
             * Sorting options, used for getting portfolio items sorted.
             * @type {SortingOptions}
             * @default
             * @private
             */
        this._sortingOptions = undefined;
        this._wfBulkStateActions = [];
        this._hasWorkflow = false;
        this._hasWfBulkActions = false;
        this._acceptableActionIds = [];
        this._wfBulkActionSubject = new Subject_1.Subject();
        this._selectedWorkflowEntityIds = [];
        this.ngUnsubscribe = new Subject_1.Subject();
        this.lastActionCommentFieldName = 'lastActionComment';
        this._currencies = new Map();
        //used for calculating min width in HTML
        this._booleanFieldsCount = 0;
        this._numberFieldsCount = 0;
        this._textFieldsCount = 0;
        this._documentFieldsCount = 0;
        this._dateFieldsCount = 0;
        this._portfolioColumnsGeneralDynamicWidth = 0;
    }
    Object.defineProperty(PortfolioService.prototype, "externalBulkActions", {
        get: function () {
            return this._externalBulkActions;
        },
        set: function (value) {
            this._externalBulkActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "externalBulkActionsByState", {
        get: function () {
            return this._externalBulkActionsByState;
        },
        set: function (value) {
            this._externalBulkActionsByState = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "defaultFilters", {
        get: function () {
            return this._defaultFilters;
        },
        set: function (value) {
            this._defaultFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "acceptableActionIds", {
        get: function () {
            return this._acceptableActionIds;
        },
        set: function (value) {
            this._acceptableActionIds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "portfolioLanguageId", {
        get: function () {
            return this._portfolioLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "portfolioColumns", {
        get: function () {
            return this._portfolioColumns;
        },
        set: function (portfolioColumns) {
            this._portfolioColumns = portfolioColumns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "searchNames", {
        get: function () {
            return this._searchNames;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "sortingOptions", {
        set: function (options) {
            this._sortingOptions = options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "totalItemsCount", {
        get: function () {
            return this._totalItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "wfBulkStateActions", {
        get: function () {
            return this._wfBulkStateActions;
        },
        set: function (value) {
            this._wfBulkStateActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "hasWorkflow", {
        get: function () {
            return this._hasWorkflow;
        },
        set: function (value) {
            this._hasWorkflow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "hasWfBulkActions", {
        get: function () {
            return this._hasWfBulkActions;
        },
        set: function (value) {
            this._hasWfBulkActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "selectedWfStateId", {
        get: function () {
            return this._selectedWfStateId;
        },
        set: function (value) {
            this._selectedWfStateId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "wfBulkActionObservable", {
        get: function () {
            return this._wfBulkActionSubject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "selectedWorkflowEntityIds", {
        get: function () {
            return this._selectedWorkflowEntityIds;
        },
        set: function (value) {
            this._selectedWorkflowEntityIds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "combinedFilters", {
        get: function () {
            return this._combinedFilters;
        },
        set: function (value) {
            this._combinedFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "currencies", {
        get: function () {
            return this._currencies;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "moneyColumnByCurrency", {
        get: function () {
            return this._moneyColumnByCurrency;
        },
        set: function (value) {
            this._moneyColumnByCurrency = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "numberFieldsCount", {
        get: function () {
            return this._numberFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "textFieldsCount", {
        get: function () {
            return this._textFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "documentFieldsCount", {
        get: function () {
            return this._documentFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "booleanFieldsCount", {
        get: function () {
            return this._booleanFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "portfolioColumnsGeneralDynamicWidth", {
        get: function () {
            return this._portfolioColumnsGeneralDynamicWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "dateFieldsCount", {
        get: function () {
            return this._dateFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioService.prototype, "advancedFilters", {
        get: function () {
            return this._advancedFilters;
        },
        set: function (value) {
            this._advancedFilters = value;
        },
        enumerable: true,
        configurable: true
    });
    PortfolioService.prototype.resetColumnCountsPerType = function () {
        this._booleanFieldsCount = 0;
        this._numberFieldsCount = 0;
        this._textFieldsCount = 0;
        this._documentFieldsCount = 0;
        this._dateFieldsCount = 0;
        this._portfolioColumnsGeneralDynamicWidth = 0;
    };
    PortfolioService.prototype.isNumberField = function (metField) {
        var type = metField.getType();
        return type == idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
            type == idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE ||
            type == idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY ||
            type == idm_kb_service_client_js_1.MetaFieldType.DECIMAL ||
            type == idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL ||
            type == idm_kb_service_client_js_1.MetaFieldType.MONEY ||
            type == idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING;
    };
    PortfolioService.prototype.isDateField = function (metField) {
        var type = metField.getType();
        return type == idm_kb_service_client_js_1.MetaFieldType.DATE ||
            type == idm_kb_service_client_js_1.MetaFieldType.DATE_TIME ||
            type == idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE ||
            type == idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME;
    };
    PortfolioService.prototype.isBooleanField = function (metField) {
        var type = metField.getType();
        return type == idm_kb_service_client_js_1.MetaFieldType.BOOLEAN;
    };
    PortfolioService.prototype.isDocumentField = function (metField) {
        var type = metField.getType();
        return type == idm_kb_service_client_js_1.MetaFieldType.DOCUMENT;
    };
    PortfolioService.prototype.isTextField = function (metField) {
        return !this.isNumberField(metField) &&
            !this.isDateField(metField) &&
            !this.isBooleanField(metField) &&
            !this.isDocumentField(metField);
    };
    PortfolioService.prototype.calculateColumnsCountByType = function (column) {
        if (this.isNumberField(column)) {
            this._numberFieldsCount++;
        }
        else if (this.isDateField(column)) {
            this._dateFieldsCount++;
        }
        else if (this.isBooleanField(column)) {
            this._booleanFieldsCount++;
        }
        else if (this.isDocumentField(column)) {
            this._documentFieldsCount++;
        }
        else if (this.isTextField(column)) {
            this._textFieldsCount++;
        }
    };
    PortfolioService.prototype.setFilterStateToQueryParam = function (state) {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { state: state.toJson() },
            queryParamsHandling: 'merge'
        });
    };
    PortfolioService.prototype.init = function (categorySystemName, columns, quickFilterSystemName, sortingOptions, categoryPermissions, additionalFieldsToLoad, categoryFieldsToLoad) {
        var _this = this;
        this.wfBulkStateActions = [];
        this.categorySystemName = categorySystemName;
        this._sortingOptions = sortingOptions;
        this._categoryFieldsToLoad = categoryFieldsToLoad;
        this.categoryPermissionTypes = categoryPermissions;
        var fieldColumnNames = columns.filter(function (column) { return column.columnType == column_type_1.ColumnType.FIELD; }).map(function (column) { return column.fieldName; });
        this.columnFields = this.processNestedColSystemNames(columns);
        if (additionalFieldsToLoad) {
            fieldColumnNames = fieldColumnNames.concat(additionalFieldsToLoad);
        }
        var metaFields$ = this.processColumnMetaFields(this.columnFields, this.categorySystemName);
        var currencies$ = skynet_store_currencies_api_1.currencyStoreManager.selectAll(this.store);
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var inputLanguages$ = this.languageService.getInputLanguages();
        var defaultLanguage$ = this.languageService.getDefaultLanguage();
        var workflowStateMetaField$ = this.kbService.getWorkflowStateMetaField(this.categorySystemName);
        return Observable_1.Observable.combineLatest(metaFields$, currencies$, currentLanguage$, inputLanguages$, defaultLanguage$, workflowStateMetaField$).pipe(operators_1.switchMap(function (data) {
            var columnDetails = data[0], currencies = data[1], currentLanguage = data[2], inputLanguages = data[3], defaultLanguage = data[4], workflowStateMetaField = data[5];
            currencies.forEach(function (currency) { return _this.currencies.set(currency.id, currency); });
            _this._portfolioColumns = [];
            _this.workflowStateMetaField = workflowStateMetaField;
            _this._currentLanguageId = currentLanguage.getId();
            //get default language
            if (inputLanguages.some(function (inputLanguage) { return inputLanguage.getId() === _this._currentLanguageId; })) {
                _this._portfolioLanguageId = _this._currentLanguageId;
            }
            else {
                _this._portfolioLanguageId = defaultLanguage.getId();
            }
            _this.processSearchFields(columnDetails.map(function (columnDetail) { return columnDetail.metaField; }));
            // in case of there is an initial advancedFilters provided from filter component,
            // filter component's search button functionality will work and here we don't need load portfolio data
            // TODO @Torpedo this is not a good solution, please change this(maybe create filter.service and inject it from portfolio.component?)
            // in case of there is an initial advancedFilters provided from filter component,
            // filter component's search button functionality will work and here we don't need load portfolio data
            // TODO @Torpedo this is not a good solution, please change this(maybe create filter.service and inject it from portfolio.component?)
            _this.initializeFieldsListToBeLoaded(fieldColumnNames, quickFilterSystemName);
            // let response$: Observable<ResponseData<Entity[]>>;
            var metaCategory$ = _this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categorySystemName));
            return metaCategory$.pipe(operators_1.switchMap(function (category) {
                _this.nameMetaFieldIds = category.getNameMetaFieldIds();
                _this.hasWorkflow = !!category.getWFProcessId();
                _this.resetColumnCountsPerType();
                _this._portfolioColumns = columnDetails.map(function (columnDetail) {
                    var dynamicWidth = columns.find(function (column) { return column.fieldName == (columnDetail.isNestedField ? (columnDetail.path + "." + columnDetail.metaField.getSystemName()) : columnDetail.metaField.getSystemName()); }).dynamicColumnWidth;
                    if (!dynamicWidth) {
                        _this.calculateColumnsCountByType(columnDetail.metaField);
                    }
                    else {
                        _this._portfolioColumnsGeneralDynamicWidth += dynamicWidth;
                    }
                    return {
                        columnDef: function (column) {
                            return column.path + '.' + column.field.getSystemName();
                        },
                        cell: function (row, column) {
                            return row.cells.find(function (cell) { return cell._metaField.getMetaFieldId().systemName == column.field.getSystemName() && cell.path === column.path; });
                        },
                        field: columnDetail.metaField,
                        columnType: table_column_type_1.TableColumnType.FIELD,
                        columnHeaderNameKey: columnDetail.columnHeaderNameKey,
                        path: columnDetail.path,
                        width: columns.find(function (column) { return column.fieldName == (columnDetail.isNestedField ? (columnDetail.path + "." + columnDetail.metaField.getSystemName()) : columnDetail.metaField.getSystemName()); }).dynamicColumnWidth,
                        isSortable: columnDetail.isSortable
                    };
                });
                // Add dynamic Component columns
                columns.forEach(function (column, index) {
                    if (column.columnType == column_type_1.ColumnType.COMPONENT) {
                        _this._portfolioColumns.splice(index, 0, {
                            columnDef: function (column) {
                                return "dynamic" + index;
                            },
                            cell: function (row, column) {
                                return null;
                            },
                            field: null,
                            column: column,
                            columnType: table_column_type_1.TableColumnType.COMPONENT,
                            width: column.dynamicColumnWidth
                        });
                        _this._portfolioColumnsGeneralDynamicWidth += column.dynamicColumnWidth;
                    }
                    else if (column.columnType == column_type_1.ColumnType.FUNCTION) {
                        _this._portfolioColumns.splice(index, 0, {
                            columnDef: function (column) {
                                return "function" + index;
                            },
                            cell: function (row, column) {
                                return null;
                            },
                            field: null,
                            column: column,
                            columnType: table_column_type_1.TableColumnType.FUNCTION,
                            width: column.dynamicColumnWidth
                        });
                        _this._portfolioColumnsGeneralDynamicWidth += column.dynamicColumnWidth;
                    }
                    else if (column.columnType == column_type_1.ColumnType.TEMPLATE) {
                        _this._portfolioColumns.splice(index, 0, {
                            columnDef: function () { return "template" + index; },
                            cell: function () { return null; },
                            field: null,
                            column: column,
                            columnType: table_column_type_1.TableColumnType.TEMPLATE,
                            width: column.dynamicColumnWidth,
                            actionsOnly: column.actionsOnly
                        });
                        _this._portfolioColumnsGeneralDynamicWidth += column.dynamicColumnWidth;
                    }
                });
                return Observable_1.Observable.of(true);
            }));
        }));
    };
    PortfolioService.prototype.getEntityIds = function () {
        var _this = this;
        var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        if (this._combinedFilters.ownFilters && !PortfolioService.isNullOrEmptyObject(this._combinedFilters.ownFilters.toJson())) {
            filterBuilder.and(this._combinedFilters.ownFilters);
        }
        if (this._combinedFilters.parentFilters && this._combinedFilters.parentFilters.length > 0) {
            return this.applyParentFilters(this._combinedFilters.parentFilters).mergeMap(function (parentFilterResult) {
                filterBuilder.and(new idm_de_core_frontend_2.InFilterCriteria(_this.integerIdentityMetaField, idm_de_core_frontend_2.FilterOperator.IN, parentFilterResult));
                return _this.entitySearchService.loadEntityFieldIds(_this.categorySystemName, _this.integerIdentityMetaField, new idm_de_core_frontend_1.PagingOptions(0, _this.totalItemsCount), undefined, filterBuilder.buildJson(), null, null, _this.kbPrefix);
            });
        }
        else {
            return this.entitySearchService.loadEntityFieldIds(this.categorySystemName, this.integerIdentityMetaField, new idm_de_core_frontend_1.PagingOptions(0, this.totalItemsCount), undefined, filterBuilder.buildJson(), null, null, this.kbPrefix);
        }
    };
    PortfolioService.prototype.doWfBulkActions = function (entityIds, actionId, comment) {
        var _this = this;
        this.deservice.doBulkWorkflowAction(this.categorySystemName, entityIds, actionId, comment).takeUntil(this.ngUnsubscribe).subscribe(function (data) {
            var movedItemsCount = Array.from(data.values()).filter(function (status) { return status == idm_de_service_client_js_1.ResponseStatus.OK; }).length;
            _this._wfBulkActionSubject.next(new wf_bulk_action_popup_model_1.WfBulkActionPopupModel(_this._totalItemsCount, movedItemsCount, entityIds.length - movedItemsCount));
        });
    };
    PortfolioService.prototype.doWfAction = function (entityId, actionId) {
        return this.deservice.doBulkWorkflowAction(this.categorySystemName, [entityId], actionId, null).map(function (responce) { return responce.get(entityId); });
    };
    PortfolioService.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    /**
     * @deprecated
     */
    /**
         * @deprecated
         */
    PortfolioService.prototype.destroy = /**
         * @deprecated
         */
    function () {
        console.warn('method is deprecated');
    };
    /**
     * Return date entry form url.
     * @param {string} categorySystemName
     * @param {number} entityInstanceId
     * @param {string} formName
     * @param {number} [formId=0]
     * @param {object} [queryParams] optional query parameters used to construct form url
     */
    /**
         * Return date entry form url.
         * @param {string} categorySystemName
         * @param {number} entityInstanceId
         * @param {string} formName
         * @param {number} [formId=0]
         * @param {object} [queryParams] optional query parameters used to construct form url
         */
    PortfolioService.prototype.navigateToDeFormUrl = /**
         * Return date entry form url.
         * @param {string} categorySystemName
         * @param {number} entityInstanceId
         * @param {string} formName
         * @param {number} [formId=0]
         * @param {object} [queryParams] optional query parameters used to construct form url
         */
    function (categorySystemName, entityInstanceId, formName, formId, queryParams) {
        if (formId === void 0) { formId = 0; }
        return this.formResolverService.getUrlForViewDeFormSync(categorySystemName, formName, entityInstanceId, formId, queryParams);
    };
    /**
     * Join all filters (quick/default , standard...)
     * @param advancedFilters
     * @param quickFilters
     */
    /**
         * Join all filters (quick/default , standard...)
         * @param advancedFilters
         * @param quickFilters
         */
    PortfolioService.prototype.joinAllFilters = /**
         * Join all filters (quick/default , standard...)
         * @param advancedFilters
         * @param quickFilters
         */
    function (advancedFilters, quickFilters) {
        var ownFiltersBuilder = undefined;
        var parentFilters = [];
        if (advancedFilters) {
            if (advancedFilters.ownFilters && !PortfolioService.isNullOrEmptyObject(advancedFilters.ownFilters.toJson())) {
                ownFiltersBuilder = ownFiltersBuilder ? ownFiltersBuilder : new idm_de_core_frontend_1.FilterBuilder();
                ownFiltersBuilder.and(advancedFilters.ownFilters);
            }
            parentFilters.push.apply(parentFilters, advancedFilters.parentFilters);
        }
        if (quickFilters) {
            ownFiltersBuilder = ownFiltersBuilder ? ownFiltersBuilder : new idm_de_core_frontend_1.FilterBuilder();
            ownFiltersBuilder.and(quickFilters);
        }
        //append default advancedFilters
        if (this._defaultFilters) {
            if (this._defaultFilters.ownFilters && !PortfolioService.isNullOrEmptyObject(this._defaultFilters.ownFilters.toJson())) {
                ownFiltersBuilder = ownFiltersBuilder ? ownFiltersBuilder : new idm_de_core_frontend_1.FilterBuilder();
                ownFiltersBuilder.and(this._defaultFilters.ownFilters);
            }
            parentFilters.push.apply(parentFilters, this._defaultFilters.parentFilters);
        }
        this.combinedFilters = new portfolio_filter_dto_1.PortfolioFilterDto(ownFiltersBuilder ? ownFiltersBuilder.build() : null, parentFilters);
        return this.combinedFilters;
    };
    PortfolioService.prototype.isWfCommentFieldRequired = function (targetStateId) {
        var _this = this;
        return this.validationService.getCategoryRequiredMetaFieldIds(this.categorySystemName, targetStateId)
            .map(function (fields) {
            return fields.map(function (f) { return f.getSystemName(); }).indexOf(_this.lastActionCommentFieldName) >= 0;
        });
    };
    PortfolioService.isNullOrEmptyObject = function (obj) {
        return obj == null || (Object.keys(obj).length === 0 && obj.constructor === Object);
    };
    PortfolioService.prototype.applyParentFilters = function (parentFilters) {
        var _this = this;
        //with this request, we get childEntity ids list, from parent entity
        //e.g. in Project portfolio page, we get projectIds list from Activity portfolio
        var responsesNum = [];
        var responsesObs = [];
        parentFilters.forEach(function (parentFilter) {
            responsesObs.push(_this.entitySearchService.loadEntityFieldIds(parentFilter.parentCategoryName, parentFilter.fieldSystemNameInParentEntity, new idm_de_core_frontend_1.PagingOptions(0, _this._pageSizeForParentFilter), null, parentFilter.parentFilterCriteria.toJson(), _this.categoryPermissionTypes, null, _this.kbPrefix));
        });
        return Observable_1.Observable.zip.apply(Observable_1.Observable, responsesObs).map(function (responses) {
            responses.forEach(function (response) {
                responsesNum.push.apply(responsesNum, response);
            });
            return responsesNum;
        });
    };
    PortfolioService.prototype.loadWfActions = function (categorySystemName, entityInstanceId) {
        return this.deservice.getPermittedActions(categorySystemName, entityInstanceId);
    };
    PortfolioService.prototype.extractColumns = function (portfolioFields, entities, nameMetaFieldIds, columnFields) {
        var _this = this;
        if (entities.length > 0) {
            return entities.map(function (entity) {
                var cells = columnFields.map(function (columnField) {
                    var isNameField = nameMetaFieldIds.find(function (metaFieldId) {
                        return metaFieldId.getSystemName() === columnField.systemName;
                    }) !== undefined;
                    if (columnField.isNested) {
                        var foundColumn = portfolioFields.find(// metaField can be null, because there are 2 columns for workflows, which has not metafield
                        // metaField can be null, because there are 2 columns for workflows, which has not metafield
                        function (// metaField can be null, because there are 2 columns for workflows, which has not metafield
                        portfolioField) {
                            return portfolioField['field'] && columnField.nestedFieldSystemName === portfolioField['field'].getSystemName()
                                && portfolioField['path'] === columnField.path;
                        });
                        if (!foundColumn) {
                            throw new Error("field " + columnField.nestedFieldSystemName + " was not found in portfolio fields");
                        }
                        else if (!columnField.nestedFieldSystemName) {
                            throw new Error('nested field system name of nested field was undefined');
                        }
                        else {
                            var columnMetaField = foundColumn;
                            if (entity.getProperty(columnField.systemName).value) {
                                return new portfolio_cell_model_1.PortfolioCellModel(columnMetaField['field'], entity.getProperty(columnField.systemName).value
                                    .getProperty(columnField.nestedFieldSystemName).value, isNameField, columnMetaField['path']);
                            }
                            else {
                                return new portfolio_cell_model_1.PortfolioCellModel(columnMetaField['field'], _this.extractValueFromField(columnMetaField['field']), isNameField, columnMetaField['path']);
                            }
                        }
                    }
                    else {
                        var foundColumn = portfolioFields.find(// metaField can be null, because there are 2 columns for workflows, which has not metafield
                        // metaField can be null, because there are 2 columns for workflows, which has not metafield
                        function (// metaField can be null, because there are 2 columns for workflows, which has not metafield
                        portfolioField) {
                            return portfolioField['field'] && columnField.systemName === portfolioField['field'].getSystemName()
                                && portfolioField['path'] === columnField.path;
                        });
                        if (!foundColumn) {
                            throw new Error("field " + columnField.systemName + " was not found in portfolio fields");
                        }
                        return new portfolio_cell_model_1.PortfolioCellModel(foundColumn['field'], entity.getProperty(foundColumn['field'].getSystemName()).value, isNameField, foundColumn['path']);
                    }
                });
                return new portfolio_row_model_1.PortfolioRowModel(cells, entity.getInstanceId(), entity);
            });
        }
        else {
            return [];
        }
    };
    /**
     * Loads portfolio items. If filter contains parent entity field advancedFilters,
     * method will send two requests, and get needed data correctly.
     *
     * @param filtersData
     * @param paging
     * @param sortingOptions
     * @param categoryPermissionTypes
     */
    /**
         * Loads portfolio items. If filter contains parent entity field advancedFilters,
         * method will send two requests, and get needed data correctly.
         *
         * @param filtersData
         * @param paging
         * @param sortingOptions
         * @param categoryPermissionTypes
         */
    PortfolioService.prototype.loadPortfolioItemsWithParentFilters = /**
         * Loads portfolio items. If filter contains parent entity field advancedFilters,
         * method will send two requests, and get needed data correctly.
         *
         * @param filtersData
         * @param paging
         * @param sortingOptions
         * @param categoryPermissionTypes
         */
    function (filtersData, externalFilters, paging, sortingOptions, categoryPermissionTypes) {
        var _this = this;
        if (filtersData.parentFilters.length > 0) {
            return this.applyParentFilters(filtersData.parentFilters)
                .mergeMap(function (entityIds) {
                if (!entityIds || entityIds.length == 0) {
                    var emptyResponse = _this.createEmptyResponse();
                    _this.loadPortfolioItemsCallBack(emptyResponse);
                    return Observable_1.Observable.of(emptyResponse);
                }
                var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
                var idFieldsFilterCriteria = new idm_de_core_frontend_2.InFilterCriteria(_this.integerIdentityMetaField, idm_de_core_frontend_2.FilterOperator.AND, entityIds);
                filterBuilder.and(idFieldsFilterCriteria);
                if (filtersData.ownFilters) {
                    filterBuilder.and(filtersData.ownFilters);
                }
                return _this.loadPortfolioItems(paging, sortingOptions, filterBuilder.buildJson(), externalFilters, categoryPermissionTypes);
            });
        }
        else {
            var filter = void 0;
            if (filtersData.ownFilters) {
                filter = filtersData.ownFilters.toJson();
            }
            else {
                filter = new idm_de_core_frontend_1.FilterBuilder().buildJson(); //reset button case
            }
            return this.loadPortfolioItems(paging, sortingOptions, filter, externalFilters, categoryPermissionTypes);
        }
    };
    /**
     * Loads values from {@link PortfolioService} by paging, sorting and {@link categorySystemName}.
     * Updates {@link _portfolioRows}, which will cause changes in view.
     * @param {PagingOptions} pagingOptions
     * @param {SortingOptions} sortingOptions
     * @param filters
     * @param externalFilters
     * @param categoryPermissionTypes
     * @private
     */
    /**
         * Loads values from {@link PortfolioService} by paging, sorting and {@link categorySystemName}.
         * Updates {@link _portfolioRows}, which will cause changes in view.
         * @param {PagingOptions} pagingOptions
         * @param {SortingOptions} sortingOptions
         * @param filters
         * @param externalFilters
         * @param categoryPermissionTypes
         * @private
         */
    PortfolioService.prototype.loadPortfolioItems = /**
         * Loads values from {@link PortfolioService} by paging, sorting and {@link categorySystemName}.
         * Updates {@link _portfolioRows}, which will cause changes in view.
         * @param {PagingOptions} pagingOptions
         * @param {SortingOptions} sortingOptions
         * @param filters
         * @param externalFilters
         * @param categoryPermissionTypes
         * @private
         */
    function (pagingOptions, sortingOptions, filters, externalFilters, categoryPermissionTypes) {
        var fieldsToLoad = new Map();
        fieldsToLoad.set(this.categorySystemName, Array.from(this.fieldsToLoad));
        if (this._categoryFieldsToLoad) {
            for (var _i = 0, _a = Array.from(this._categoryFieldsToLoad.keys()); _i < _a.length; _i++) {
                var category = _a[_i];
                fieldsToLoad.set(category, this._categoryFieldsToLoad.get(category));
            }
        }
        return this.entitySearchService.loadPortfolioItemsByFields2(this.categorySystemName, pagingOptions, sortingOptions, filters, externalFilters, categoryPermissionTypes, fieldsToLoad, this.kbPrefix);
    };
    PortfolioService.prototype.loadPortfolioItemsCallBack = function (response) {
        this.processMetaFrom(response);
        return this.extractColumns(this._portfolioColumns, response.getData(), this.nameMetaFieldIds, this.columnFields);
    };
    /**
     * Processes metadata from {@link ServiceResponse}.
     * Gets all items count and calculates pages count.
     * @param {ServiceResponse<any>} serviceResponse
     * @private
     */
    /**
         * Processes metadata from {@link ServiceResponse}.
         * Gets all items count and calculates pages count.
         * @param {ServiceResponse<any>} serviceResponse
         * @private
         */
    PortfolioService.prototype.processMetaFrom = /**
         * Processes metadata from {@link ServiceResponse}.
         * Gets all items count and calculates pages count.
         * @param {ServiceResponse<any>} serviceResponse
         * @private
         */
    function (serviceResponse) {
        this._totalItemsCount = serviceResponse.getTotalRowCount();
    };
    PortfolioService.prototype.processWfActions = function (stateId) {
        var _this = this;
        this.selectedWfStateId = stateId;
        if (this.acceptableActionIds) {
            this.actionService.getActionsByStateId(stateId).then(function (actions) {
                _this.wfBulkStateActions = actions.filter(function (action) { return _this.acceptableActionIds.includes(action.getId()); });
            });
        }
    };
    PortfolioService.prototype.processSearchFields = function (allFields) {
        var _this = this;
        this._searchNames = new Map();
        allFields.forEach(function (field) {
            switch (field.getType()) {
                case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING: {
                    _this._searchNames.set(field.getSystemName(), field.getSystemName() + "." + _this._portfolioLanguageId);
                    break;
                }
                case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                    var fieldName = field.getSystemName();
                    var currencyId = _this.moneyColumnByCurrency.get(fieldName);
                    _this._searchNames.set(fieldName, fieldName + ".currencyMoney." + currencyId);
                    break;
                }
                case idm_kb_service_client_js_1.MetaFieldType.MONEY: {
                    var fieldName = field.getSystemName();
                    _this._searchNames.set(fieldName, fieldName + ".amount");
                    break;
                }
                default: {
                    if (!_this._searchNames.has(field.getSystemName())) {
                        _this._searchNames.set(field.getSystemName(), field.getSystemName());
                    }
                }
            }
        });
    };
    PortfolioService.prototype.processNestedColSystemNames = function (columnmodels) {
        return columnmodels.filter(function (column) { return column.columnType == column_type_1.ColumnType.FIELD; }).map(function (columnModel) {
            var splits = columnModel.fieldName.split('.');
            return {
                isNested: splits.length > 1,
                nestedFieldSystemName: splits.length > 1 ? splits[1] : undefined,
                systemName: splits[0],
                columnHeaderNameKey: columnModel.columnHeaderNameKey,
                path: splits.length > 1 ? splits.slice(0, -1).join('.') : splits[0]
            };
        });
    };
    PortfolioService.prototype.createEmptyResponse = function () {
        var resp = new idm_entity_search_client_js_1.ResponseData();
        resp.setTotalRowCount(0);
        resp.setData([]);
        return resp;
    };
    PortfolioService.prototype.processColumnMetaFields = function (columnFields, categorySystemName) {
        var _this = this;
        return this.kbService.getMetaFields(categorySystemName)
            .mergeMap(function (metaFields) {
            _this.integerIdentityMetaField = metaFields.find(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; }).getSystemName();
            return Observable_1.Observable.zip.apply(Observable_1.Observable, columnFields.map(function (columnField) {
                if (!columnField.isNested) {
                    var columnMetaField = metaFields.find(function (metaField) {
                        return metaField.getSystemName() === columnField.systemName;
                    });
                    if (!columnMetaField) {
                        throw new Error("no field found for " + columnField.systemName + " column");
                    }
                    var isSortable = _this.isSortableColumn(columnMetaField.getType());
                    return Observable_1.Observable.of({
                        metaField: columnMetaField,
                        columnHeaderNameKey: columnField.columnHeaderNameKey,
                        path: columnField.path,
                        isNestedField: false,
                        isSortable: isSortable
                    });
                }
                else {
                    return _this.kbService.getMainEntityMetaFields(categorySystemName, columnField.systemName)
                        .map(function (mainEntityMetaFields) {
                        var mainEntityMetaField = mainEntityMetaFields.find(function (metaField) {
                            return metaField.getSystemName() === columnField.nestedFieldSystemName;
                        });
                        if (!mainEntityMetaField) {
                            throw new Error("no field found for " + columnField.systemName + " column");
                        }
                        return {
                            metaField: mainEntityMetaField,
                            columnHeaderNameKey: columnField.columnHeaderNameKey,
                            path: columnField.path,
                            isNestedField: true,
                            isSortable: false
                        };
                    });
                }
            }));
        });
    };
    PortfolioService.prototype.extractValueFromField = function (metaField) {
        return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING ?
            idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().withValueForLanguage(this.currentLanguageId, '').build() : undefined;
    };
    PortfolioService.prototype.isSortableColumn = function (type) {
        return type != idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY &&
            type != idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT &&
            type != idm_kb_service_client_js_1.MetaFieldType.DOCUMENT &&
            type != idm_kb_service_client_js_1.MetaFieldType.PARENT &&
            type != idm_kb_service_client_js_1.MetaFieldType.USER;
    };
    //======================================
    //======================================
    PortfolioService.prototype.onChangeSearchFilterHandler = 
    //======================================
    function (searchFilterDto) {
        return Observable_1.Observable.of(new idm_entity_search_client_js_1.ResponseData());
    };
    PortfolioService.prototype.onChangeFilterHandler = function (filterDto) {
        this._advancedFilters = filterDto;
        this.selectedWorkflowEntityIds = [];
    };
    PortfolioService.prototype.onChangeQuickFilterHandler = function (quickFilterDto) {
        this._quickFilters = quickFilterDto;
        if (this._hasWfBulkActions && quickFilterDto.selectedId != -1) {
            this.processWfActions(quickFilterDto.selectedId);
            this.externalBulkActionsByState = this.externalBulkActions.filter(function (action) { return action.acceptableStateIds && action.acceptableStateIds.indexOf(quickFilterDto.selectedId) >= 0; });
        }
        else {
            this.wfBulkStateActions = [];
            this.externalBulkActionsByState = [];
            this.selectedWfStateId = null;
        }
        this.selectedWorkflowEntityIds = [];
    };
    PortfolioService.prototype.initWfActionsAndState = function (selectedId) {
        this.wfBulkStateActions = [];
        if (this._hasWfBulkActions && selectedId != -1) {
            this.processWfActions(selectedId);
            this.externalBulkActionsByState = this.externalBulkActions.filter(function (action) { return action.acceptableStateIds && action.acceptableStateIds.indexOf(selectedId) >= 0; });
        }
    };
    /**
     * Collect field list, which should be loaded and deserialized from entity service
     * @param columnSystemNames
     * @param quickFilterSystemName
     */
    /**
         * Collect field list, which should be loaded and deserialized from entity service
         * @param columnSystemNames
         * @param quickFilterSystemName
         */
    PortfolioService.prototype.initializeFieldsListToBeLoaded = /**
         * Collect field list, which should be loaded and deserialized from entity service
         * @param columnSystemNames
         * @param quickFilterSystemName
         */
    function (columnSystemNames, quickFilterSystemName) {
        var _this = this;
        this.fieldsToLoad = new Set();
        columnSystemNames.forEach(function (columnSystemName) {
            if (columnSystemName.indexOf(".") < 0 || columnSystemName.toLocaleLowerCase().startsWith(_this.categorySystemName.toLocaleLowerCase())) {
                _this.fieldsToLoad.add(columnSystemName);
            }
        });
        //additional fields should be loaded
        this.fieldsToLoad.add(this.integerIdentityMetaField);
        if (quickFilterSystemName) {
            this.fieldsToLoad.add(quickFilterSystemName);
        }
        else if (this.workflowStateMetaField) {
            this.fieldsToLoad.add(this.workflowStateMetaField.getSystemName());
        }
    };
    PortfolioService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    PortfolioService.ctorParameters = function () { return [
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
        { type: idm_kb_service_client_js_1.KbService, },
        { type: idm_frontend_shared_1.FormResolverService, },
        { type: idm_entity_search_client_js_1.EntitySearchService, },
        { type: idm_workflow_service_client_js_1.ActionService, },
        { type: idm_de_service_client_js_1.DeService, },
        { type: idm_validation_calculation_service_client_js_1.ValidationService, },
        { type: store_1.Store, },
        { type: router_1.Router, },
        { type: router_1.ActivatedRoute, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
        { type: undefined, decorators: [{ type: core_1.Optional }, { type: core_1.Inject, args: [kb_prefix_1.KbPrefix,] },] },
    ]; };
    return PortfolioService;
}());
exports.PortfolioService = PortfolioService;
//# sourceMappingURL=portfolio.service.js.map